<template>
    <sub-page :fullPage="true" id="cert-box">

        <el-row :gutter="20" class="certificate">
            <!--持证人基本个人信息            -->
            <el-col :span="6" class="certificate-holder" style="padding-left: 0; padding-right: 0">
                <!--<div v-if="holderInfoShow||userID" class="holder-info">-->
                <div class="holder-info">
                    <el-row class="holder-head">
                        <img v-if="currentUser&&currentUser.avatar" :src="currentUser.avatar" alt="持证人头像"/>
                        <img v-else src="../../assets/images/common/default_avatar.jpg" alt="持证人头像"/>
                        <p>{{$t('c.username')}}：{{currentUser?currentUser.name:$t('c.none')}}</p>
                    </el-row>
                    <el-row class="holder-body">
                        <ul>
                            <li><h5>{{$t('c.account')}}：</h5><span>{{currentUser?(currentUser.accountNo||$t('c.none')):$t('c.none')}}</span>
                            </li>
                            <li><h5>{{$t('c.gender')}}：</h5><span>{{currentUser?(currentUser.sexName||$t('c.none')):$t('c.none')}}</span>
                            </li>
                            <li><h5>{{$t('c.birthday')}}：</h5><span>{{currentUser?(currentUser.birthDay?currentUser.birthDay.substring(0,10):$t('c.none')):$t('c.none')}}</span>
                            </li>
                            <li><h5>{{$t('c.phone')}}：</h5><span>{{currentUser?(currentUser.mobile||$t('c.none')):$t('c.none')}}</span>
                            </li>
                            <li><h5>{{$t('c.idCardNo')}}：</h5><span>{{currentUser?(currentUser.idCard||$t('c.none')):$t('c.none')}}</span>
                            </li>
                            <li><h5>{{$t('c.education')}}：</h5><span>{{currentUser?(currentUser.educationName||$t('c.none')):$t('c.none')}}</span>
                            </li>
                            <li><h5>{{$t('c.belong')}}：</h5><span>{{currentUser?(currentUser.orgName||$t('c.none')):$t('c.none')}}</span>
                            </li>
                            <li><h5>{{$t('c.grade')}}：</h5><span>{{currentUser?(currentUser.gradeName||$t('c.none')):$t('c.none')}}</span>
                            </li>
                            <li><h5>{{$t('c.position')}}：</h5><span>{{currentUser?(currentUser.postName||$t('c.none')):$t('c.none')}}</span>
                            </li>
                            <li><h5>{{$t('c.occupation')}}：</h5>
                                <span>{{currentUser?(currentUser.typeName||$t('c.none')):$t('c.none')}}</span></li>
                            <li><h5>{{$t('c.employmentDate')}}：</h5><span>{{currentUser?(currentUser.employmentDate?currentUser.employmentDate.substring(0,10):$t('c.none')):$t('c.none')}}</span></li>
                        </ul>
                        <el-button v-if="holderInfoShow||userID"
                                   size="small"
                                   class="holder-btn"
                                   @click="addCertificates()">{{$t('cert.certAddTip')}}
                        </el-button>
                        <el-button v-else
                                   size="small"
                                   class="holder-btn"
                                   @click="selectUser">
                            {{$t('cert.selectHolderTip')}}
                        </el-button>
                    </el-row>
                </div>
            </el-col>
            <!--持有的证书及证书详情-->
            <el-col v-if="holderInfoShow||userID" :span="16" style="padding-left: 0">
                <div v-if="userID && userCertList && userCertList.length>0" class="cert-container" v-viewer="false">
                    <el-tabs type="border-card" tab-position="top" v-model="activeTab" style="height: 100%">
                        <el-tab-pane v-for="(list, index) in userCertList"
                                     :label="list.typeName"
                                     :name="''+index"
                                     :key="list.typeName"
                                     style="width: 100%; height: 100%; overflow: auto"
                                     v-loading="dangerLoading"
                        >
                            <template v-if="activeTab == index">
                                <!--证书详情-->
                                <el-card class="box-card cert-box-card" shadow="none">
                                    <div slot="header" class="clearfix">
                                        <span style="font-size: 14px"><i class="nucfont inuc-zhengshuxiangqing"></i>{{list.typeName}}-{{$t('cert.certInfo')}}</span>
                                        <el-button style="float: right; padding: 8px 0 3px; margin: 0 10px;" type="text"
                                                   @click="deleteCert(list.id)"><i class="nucfont inuc-delete"></i>
                                        </el-button>
                                        <el-button style="float: right; padding: 8px 0 3px" type="text"
                                                   @click="addCertificates(list.id)"><i class="nucfont inuc-edit"></i>
                                        </el-button>
                                    </div>
                                    <div class="cert-info">
                                        <ul>
                                            <li>{{$t('cert.certName')}}：{{list.typeName}}</li>
                                            <li>{{$t('cert.certNum')}}：{{list.number}}</li>
                                            <li>
                                                {{$t('cert.releaseDate')}}：{{list.releaseDate?list.releaseDate.substring(0,10):$t('c.none')}}
                                            </li>
                                            <li>
                                                {{$t('cert.obtainDate')}}：{{list.operateDate?list.operateDate.substring(0,10):$t('c.none')}}
                                            </li>
                                            <li>
                                                {{$t('cert.reviewDate')}}：{{list.reviewDate?list.reviewDate.substring(0,10):$t('c.none')}}
                                            </li>
                                            <li v-if="list.type!=2">{{$t('cert.theoryScore')}}：{{list.theoryScore ? list.theoryScore : '-'}}
                                            </li>
                                            <li v-if="list.type!=2">
                                                {{$t('cert.operationScore')}}：{{list.operationScore ? list.operationScore : '-'}}
                                            </li>
                                            <li v-if="list.type!=2">{{$t('cert.gradeName')}}：{{list.gradeName ? list.gradeName : '-'}}</li>

                                            <li v-if="dangerEnterprise.includes(enterpriseCode) && list.type==2">
                                                证书照片：
                                                <div class="elec-danger-image">
                                                    <img v-if="list.photo" :src="showImage(list.photo)" class="avatar">
                                                    <span v-else class="shuaxin-image" title="刷新生成电子证书" @click="makeElecImage">
                                                    <i class="nucfont inuc-tongbu"></i>
                                                </span>
                                                </div>
                                            </li>

                                            <li v-else>
                                                证书照片：
                                                <el-upload
                                                    class="avatar-uploader"
                                                    :action="imgUploadApi"
                                                    :data="uploadParams(list.id)"
                                                    accept=".jpg,.jpeg,.bmp,.png"
                                                    name="upfile"
                                                    :show-file-list="false"
                                                    :on-success="handleAvatarSuccess"
                                                    :disabled="!!list.photo"
                                                >
                                                    <img v-if="list.photo" :src="showImage(list.photo)" class="avatar">
                                                    <i class="el-icon-plus avatar-uploader-icon" title="添加证书照片" v-else></i>
                                                    <div class="mask" v-if="list.photo">
                                                        <i class="nucfont inuc-delete delete-cover" title="删除证书照片"
                                                           @click="deleteImage(list.id)"></i>
                                                    </div>
                                                </el-upload>
                                            </li>

                                        </ul>
                                    </div>
                                </el-card>
                                <!--复训记录-->
                                <el-card class="box-card detail-box-card" shadow="none">
                                    <div slot="header" class="clearfix">
                                        <span style="font-size: 14px"><i class="nucfont inuc-fuxunjilu"></i>{{list.typeName}}-{{$t('cert.retrainRecord')}}</span>
                                        <el-button style="float: right; padding: 8px 0 3px" type="text"
                                                   @click="addDetail(list)"><i class="nucfont inuc-add-circle"></i>
                                        </el-button>
                                    </div>
                                    <div class="cert-detail">
                                        <!--危险品证书-->
                                        <div v-if="list.type==2">
                                            <div
                                                v-for="(item, index) in list.details"
                                                class="cert-detail-title">
                                                <!--左侧icon-->
                                                <div v-if="index==0" class="icon-style">
                                                    <i class="nucfont inuc-zhengshu"></i>
                                                </div>
                                                <div v-if="index!=0" class="icon-style icon-style-1">
                                                    <i class="nucfont inuc-fuxun"></i>
                                                </div>
                                                <h3>
                                                    <el-tag v-if="index==0" class="detail-tag" size="mini" color="#f4f3f8" style="color: #1c84c6; font-size: 14px">{{$t('cert.obtainCert')}}</el-tag>
                                                    <el-tag v-else type="warning" class="detail-tag" size="mini" color="#f4f3f8" style="font-size: 14px">{{$t('cert.retrain')}}</el-tag>
                                                    <el-button style="float: right; padding: 3px 0; margin: 0 10px;"
                                                               type="text"
                                                               @click="deleteDetail(item)"><i
                                                        class="nucfont inuc-delete"></i>
                                                    </el-button>
                                                    <el-button style="float: right; padding: 3px 0" type="text"
                                                               @click="editDetail(item, 'danger')"><i
                                                        class="nucfont inuc-edit"></i>
                                                    </el-button>
                                                </h3>
                                                <ul class="danger-detail-list">
                                                    <li>{{index==0? ($t('cert.releaseDate')+'：'
                                                    ):($t('cert.retrainDate')+'：')}}{{index==0?list.releaseDate.substring(0,10):item.trainDate.substring(0,10)}}</li>
                                                    <li>{{$t('cert.trainSubject')}}：{{item.teachingBook}}</li>
                                                    <li>{{$t('cert.trainInstitution')}}：{{item.agency}}</li>
                                                    <li>{{$t('train.site')}}：{{item.place}}</li>
                                                    <li>{{$t('cert.trainerName')}}：{{item.trainerName}}</li>
                                                    <li>{{$t('cert.personType')}}：{{item.category}}类</li>
                                                    <li>{{$t('cert.trainConclusion')}}：{{item.gradeName ? item.gradeName : '-'}}</li>
                                                    <li></li>
                                                </ul>
                                            </div>
                                        </div>
                                        <!--职业资格证书-->
                                        <div v-if="list.type!=2">
                                            <div class="cert-detail-title">
                                                <div class="icon-style">
                                                    <i class="nucfont inuc-zhengshu"></i>
                                                </div>
                                                <el-tag class="detail-tag" size="mini" color="#f4f3f8" style="color: #1c84c6; font-size: 14px">{{$t('cert.obtainCert')}}</el-tag>
                                                <p>{{$t('cert.releaseDate')}}：{{list.releaseDate?list.releaseDate.substring(0,10):$t('c.none')}}</p>
                                            </div>
                                            <div v-if="list.details && list.details!=[]" v-for="item in list.details"
                                                 class="cert-detail-title" :key="item.id">
                                                <div class="icon-style icon-style-1">
                                                    <i class="nucfont inuc-fuxun"></i>
                                                </div>
                                                <h3>
                                                    <el-tag type="warning" class="detail-tag" size="mini" color="#f4f3f8" style="font-size: 14px">{{$t('cert.retrain')}}</el-tag>
                                                    <el-button style="float: right; padding: 3px 0; margin: 0 10px;"
                                                               type="text"
                                                               @click="deleteDetail(item)"><i
                                                        class="nucfont inuc-delete"></i>
                                                    </el-button>
                                                    <el-button style="float: right; padding: 3px 0" type="text"
                                                               @click="editDetail(item, 'ordinary')"><i
                                                        class="nucfont inuc-edit"></i>
                                                    </el-button>
                                                </h3>
                                                <p>{{$t('cert.retrainDate')}}：{{item.trainDate?item.trainDate.substring(0,10):$t('c.none')}}</p>
                                                <p>{{$t('cert.retrainGrade')}}：{{item.score ? item.score : '-'}}</p>
                                            </div>
                                        </div>
                                    </div>
                                </el-card>
                            </template>
                        </el-tab-pane>
                    </el-tabs>
                </div>
                <div v-if="userCertList.length==0 || !userCertList" class="certificate-info">
                    <el-tag size="medium" class="notice-tag">{{$t('cert.certAddTip_1')}}</el-tag>
                </div>
            </el-col>
            <el-col v-else :span="16" style="padding-left: 0">
                <div class="certificate-info">
                    <el-tag size="medium" class="notice-tag">{{$t('cert.howToTip')}}</el-tag>
                </div>
            </el-col>
        </el-row>
        <!-- <el-dialog
            title="电子证书"
            :visible.sync="dialogVisible"
            :modal-append-to-body="appendToBody"
            width="1200px"
            :before-close="handleClose"
            > -->
            <div id="imageDom">
                <div class="proBox">
                    <div class="shenzhen-logo">
                        <img src="../../assets/images/common/shenzhen_logo.png" alt="">
                    </div>
                    <p class="tit"><center>中国民用航空危险品运输训练合格证</center></p>
                    <p class="sub-title"><center>Training Records of Dangerous Goods Transport Civil Aviation of China</center></p>
                    <div class="s-cert-info">
                        <div class="s-cert-overdue" v-if="isDangerOverdue">
                            <img src="../../assets/images/common/overdue.png" alt="">
                        </div>

                        <ul class="s-person-info">
                            <div class="s-user-photo">
                                <img v-if="currentUser&&currentUser.avatar" crossorigin="anonymous" :src="avatarLazy(currentUser.avatar)"/>
                                <img v-else src="../../assets/images/common/default_avatar.jpg"/>
                            </div>
                            <li class="s-person-item">持证人姓名：{{currentUser?currentUser.name:$t('c.none')}}</li>
                            <li class="s-person-item">Name of This Records Holder</li>
                            <li class="s-person-item">身份证号：{{currentUser?(currentUser.idCard||$t('c.none')):$t('c.none')}}</li>
                            <li class="s-person-item">RECORDS No.(ID No.)</li>
                            <li class="s-person-item">人员类别：{{dangerCategory?(dangerCategory+'类'):$t('c.none')}}</li>
                            <li class="s-person-item">Category</li>
                            <li class="s-person-item">训练机构(盖章)：</li>
                            <li class="s-person-item">Training center</li>
                            <li class="s-person-item">签发之日：{{dangerReleaseDate?dangerReleaseDate:$t('c.none')}}</li>
                             <li class="s-person-item">Date of issue</li>
                            <li class="s-person-item">证书编号：{{dangerNumber?dangerNumber:$t('c.none')}}</li>
                             <li class="s-person-item">Record No.</li>
                            <li class="s-person-item">所在部门：{{dangerNumber?dangerNumber:$t('c.none')}}</li>
                             <li class="s-person-item">Department</li>
                            <!-- <li class="s-person-item">有效期：自证书签发之日起2年有效</li> -->
                        </ul>
                        <div class="s-cert-list">
                            <el-table
                                :data="certTableData"
                                :cell-style="rowStyle"
                                 stripe>
                                <el-table-column prop="approvalNo" label="" width="150" align="center">
                                    <template slot="header">
                                        <div style="letter-spacing:1px">训练大纲批准号</div>
                                    </template>
                                    <template slot-scope="scope">
                                        {{scope.row.approvalNo}}
                                    </template>
                                </el-table-column>

                                <el-table-column prop="trainDate" align="center" width="140">
                                    <template slot="header">
                                        <div style="letter-spacing:1px">培训日期</div>
                                        <div>Date of</div>
                                        <div>Training</div>
                                    </template>
                                    <template slot-scope="scope">
                                        {{scope.row.trainDate?scope.row.trainDate.substring(0,10):''}}
                                    </template>
                                </el-table-column>
                                <el-table-column prop="teachingBook" align="center" width="140" show-overflow-tooltip>
                                    <template slot="header">
                                        <div style="letter-spacing:1px">培训科目</div>
                                        <div>Subject of</div>
                                        <div>Training</div>
                                    </template>
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.teachingBook }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="category" align="center" width="120">
                                    <template slot="header">
                                        <div style="letter-spacing:1px">人员类别</div>
                                        <div>Category</div>
                                    </template>
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.category}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="gradeName" align="center"  width="120">
                                    <template slot="header">
                                        <div style="letter-spacing:1px">考核结论</div>
                                        <div>Examine</div>
                                        <div>Result</div>
                                    </template>
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.gradeName }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="trainerName" align="center" width="120" show-overflow-tooltip>
                                    <template slot="header">
                                        <div style="letter-spacing:1px">授课教员</div>
                                        <div>Instructor</div>
                                    </template>
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.trainerName }}</span>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                    <div class="chapter">
                        <canvas id="chapterCanvas" width="200" height="200"></canvas>
                    </div>
                </div>
            </div>
            <!-- <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="getElecDangerImage('#imageDom')">保存</el-button>
            </span>
         </el-dialog> -->
        <!--为用户添加、修改证书-->
        <el-dialog :title="isCertEdit? $t('cert.editCert'):$t('cert.addCert')"
                   :visible.sync="dialogFormVisible"
                   :modal-append-to-body="appendToBody"
                   width="450px"
        >
            <el-form :label-width="$i18n.locale === 'en' ? '150px':'120px' "
                     :model="formData" class="dialogForm" size="mini" ref="addCerts"
                     :rules="certRules">
                <el-form-item :label="$t('cert.certNum')" prop="number">
                    <el-input v-model="formData.number" class="el-style"></el-input>
                </el-form-item>
                <el-form-item :label="$t('cert.type')" width="250px" prop="type">
                    <el-select v-model="formData.type" class="el-style" :disabled="isCertEdit">
                        <el-option :label="$t('cert.juniorProCert')" :value="11"></el-option>
                        <el-option :label="$t('cert.IntermediateProCert')" :value="21"></el-option>
                        <el-option :label="$t('cert.seniorProCert')" :value="31"></el-option>
                        <el-option :label="$t('cert.technicianProCert')" :value="41"></el-option>
                        <el-option :label="$t('cert.technicianProPlusCert')" :value="51"></el-option>
                        <el-option :label="$t('cert.dangerCert')" :value="2"></el-option>
                    </el-select>
                </el-form-item>
                <div v-if="formData.type=='2' && !isCertEdit" label-width="100px">
                    <el-form-item :label="$t('cert.trainInstitution')" prop="agency">
                        <el-input v-model="formData.agency" class="el-style"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('train.site')" prop="place">
                        <el-input v-model="formData.place" class="el-style"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('cert.trainSubject')" prop="teachingBook">
                        <el-input v-model="formData.teachingBook"
                                  class="el-style"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('cert.trainerName')" prop="trainerName">
                        <el-input v-model="formData.trainerName" class="el-style"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('cert.personType')" prop="category">
                        <el-select v-model="formData.category" class="el-style">
                            <el-option label="8" value="8"></el-option>
                            <el-option label="12" value="12"></el-option>
                        </el-select>
                    </el-form-item>
                </div>
                <div v-if="formData.type!='2'">
                    <el-form-item :label="$t('cert.theoryScore')" prop="theoryScore">
                        <el-input v-model="formData.theoryScore" class="el-style"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('cert.operationScore')" prop="operationScore">
                        <el-input v-model="formData.operationScore" class="el-style"></el-input>
                    </el-form-item>
                </div>
                <el-form-item :hidden="formData.type=='2' && isCertEdit"
                              :label="formData.type!='2'?$t('cert.gradeName'):$t('cert.trainConclusion')"
                              width="250px" prop="grade">
                    <el-select v-model="formData.grade" class="el-style">
                        <el-option :label="$t('cert.qualified')" :value="2"></el-option>
                        <el-option :label="$t('cert.good')" :value="3"></el-option>
                        <el-option :label="$t('cert.excellent')" :value="4"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('cert.releaseDate')" width="250px" prop="releaseDate">
                    <el-date-picker
                        v-model="formData.releaseDate"
                        align="right"
                        type="date"
                        :placeholder="$t('tip.date')"
                        value-format="yyyy-MM-dd"
                        class="el-style">
                    </el-date-picker>
                </el-form-item>
                <el-form-item :label="$t('cert.obtainDate')" width="250px" prop="operateDate">
                    <el-date-picker
                        v-model="formData.operateDate"
                        align="right"
                        type="date"
                        :placeholder="$t('tip.date')"
                        value-format="yyyy-MM-dd"
                        class="el-style">
                    </el-date-picker>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer" style="text-align: center;margin-bottom: 10px;">
                <el-button type="primary" size="small" @click="addCertSubmit('addCerts','certsDetail')">
                    {{$t('c.confirm')}}
                </el-button>
            </div>
        </el-dialog>
        <!--选择用户-->
        <el-dialog :title="$t('cert.selectUser')"
                   :visible.sync="selectUserVisible"
                   :append-to-body="true"
                   :modal-append-to-body="true"
                   width="850px"
                   class="addUser"
        >
            <el-form :inline="true" size="mini" style="padding: 10px 10px 0;">
                <el-form-item :label="$t('c.userInfo')">
                    <el-input v-model="userSearch.search" :placeholder="$t('tip.userSearch')" class="el-style"
                              style="width: 180px"></el-input>
                </el-form-item>
                <select-multi-orgs @orgsChange="orgsChange"></select-multi-orgs>
                <el-form-item>
                    <el-button type="primary" @click="queryUser" round>{{$t('c.query')}}</el-button>
                </el-form-item>
            </el-form>
            <data-tables ref="userTable"
                         :data="tableData"
                         :table-props="tableProps"
                         :current-page.sync="currentPage"
                         :page-size="20"
                         :pagination-props="{pageSizes: [20, 50, 100, 300, 500]}"
                         @current-change="handleCurrentChange"
                         @row-click="showRow"
            >
                <!--单选框-->
                <el-table-column :label="$t('c.status')" width="55" align="center">
                    <template slot-scope="scope">
                        <el-radio class="radio" v-model="radio" :label="scope.row.id"
                                  @change.native="getCurrentRow(scope.row.id)">&nbsp;
                            {{''}}
                        </el-radio>
                    </template>
                </el-table-column>

                <el-table-column v-for="(title, index) in titles" :prop="title.prop" :label="title.label"
                                 :key="index"
                                 align="center"
                                 show-overflow-tooltip
                                 sortable="custom">
                </el-table-column>
            </data-tables>
            <div class="dialog-footer">
                <el-button class="addUser-btn" size="small" @click="selectUserVisible = false">{{$t('c.cancel')}}
                </el-button>
                <el-button class="addUser-btn" size="small" type="primary" @click="submitUser">{{$t('c.confirm')}}
                </el-button>
            </div>
        </el-dialog>
        <!--添加复训记录-->
        <el-dialog :title="!isEditDetail? $t('cert.addRecord'):$t('cert.editRecord')"
                   :visible.sync="certDetailVisible"
                   :modal-append-to-body="appendToBody"
                   width="450px"
        >
            <el-form :label-width="$i18n.locale === 'en' ? '150px':'120px'"
                     :model="detailData" class="dialogForm" size="mini" ref="addCertsRecord"
                     :rules="certRules">
                <div v-if="detailType=='2'">
                    <el-form-item :label="$t('cert.trainInstitution')" prop="agency">
                        <el-input v-model="detailData.agency" class="el-style"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('train.site')" prop="place">
                        <el-input v-model="detailData.place" class="el-style"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('cert.trainSubject')" prop="teachingBook">
                        <el-input v-model="detailData.teachingBook"
                                  class="el-style"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('cert.trainerName')" prop="trainerName">
                        <el-input v-model="detailData.trainerName" class="el-style"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('cert.personType')" prop="category">
                        <el-select v-model="detailData.category" class="el-style">
                            <el-option label="8" value="8"></el-option>
                            <el-option label="12" value="12"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('cert.trainConclusion')" prop="grade">
                        <el-select v-model="detailData.grade" class="el-style">
                            <el-option :label="$t('cert.qualified')" :value="2"></el-option>
                            <el-option :label="$t('cert.good')" :value="3"></el-option>
                            <el-option :label="$t('cert.excellent')" :value="4"></el-option>
                        </el-select>
                    </el-form-item>
                </div>
                <div v-if="detailType!='2'">
                    <el-form-item :label="$t('cert.retrainGrade')" prop="score">
                        <el-input v-model="detailData.score" class="el-style"></el-input>
                    </el-form-item>
                </div>
                <el-form-item :label="$t('cert.retrainDate')" width="250px" prop="trainDate">
                    <el-date-picker
                        v-model="detailData.trainDate"
                        align="right"
                        type="date"
                        :placeholder="$t('tip.date')"
                        value-format="yyyy-MM-dd"
                        class="el-style">
                    </el-date-picker>
                </el-form-item>
                <el-form-item :label="$t('cert.reviewDate')" width="250px" prop="reviewDate">
                    <el-date-picker
                        v-model="detailData.reviewDate"
                        align="right"
                        type="date"
                        :placeholder="$t('tip.date')"
                        value-format="yyyy-MM-dd"
                        class="el-style">
                    </el-date-picker>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" type="primary" @click="addDetailSubmit('addCertsRecord')">{{$t('c.confirm')}}
                </el-button>
            </div>
        </el-dialog>
    </sub-page>
</template>

<script>
    import api from '@/api';
    import {Ticket} from '@/utils';
    import SubPage from '@/components/Subpage';
    import SelectMultiOrgs from '@/components/SelectMultiOrgs';
    import {mapGetters} from 'vuex';
    import html2Canvas from 'html2canvas'

    export default {
        data() {
            return {
                canvasUrl: '',
                dangerEnterprise: ['300', '100', '12'],
                userID: this.$route.params.userID,
                tableData: [],// 用户列表开始
                tableProps: {
                    border: false,
                    stripe: true,
                    rowKey: row => row.id,
                    height: "40vh"
                },
                titles: [
                    {
                        prop: 'name',
                        label: this.$t('c.username')
                    }, {
                        prop: 'accountNo',
                        label: this.$t('c.account')
                    }, {
                        prop: 'mobile',
                        label: this.$t('c.phone')
                    }, {
                        prop: 'typeName',
                        label: this.$t('c.occupation')
                    }, {
                        prop: 'orgName',
                        label: this.$t('c.belong')
                    }, {
                        prop: 'idCard',
                        label: this.$t('c.idCardNo')
                    }, {
                        prop: 'employmentDate',
                        label: this.$t('c.employmentDate')
                    }
                ],
                currentPage: 1,// 用户列表结束
                currentUser: undefined,
                avatarURL: '../../assets/images/common/default_avatar.jpg',
                userCertList: [],
                userCertDetail: [],
                activeTab: '0',

                certID: undefined,
                formData: {
                    userID: this.$route.params.userID,
                    number: undefined,
                    type: undefined,
                    theoryScore: undefined,
                    operationScore: undefined,
                    releaseDate: undefined,
                    operateDate: undefined,//取证
                    grade: undefined,
                    details: undefined,
                    place: undefined,
                    agency: undefined,
                    trainerName: undefined,
                    teachingBook: undefined,
                    category: undefined,
                },
                details: [{
                    place: undefined,
                    agency: undefined,
                    trainerName: undefined,
                    teachingBook: undefined,
                    category: undefined,
                    score: undefined,//复训成绩，只有职业资格证书显示该字段
                }],
                radio: '',
                userSearch: {//搜索持证人
                    search: undefined,
                    orgIds: []
                },
                detailList: [],
                detailType: '',
                detailData: {
                    id: undefined,
                    certID: undefined,
                    place: undefined,
                    agency: undefined,
                    category: undefined,
                    trainerName: undefined,
                    teachingBook: undefined,
                    score: undefined,
                    reviewDate: undefined,
                    trainDate: undefined,
                    grade: undefined
                },
                certRules: {
                    number: [
                        {required: true, message: this.$t('rule.required'), trigger: 'blur'},
                        {max: 100, message: this.$t('rule.maxLength', ['100']), trigger: 'blur'}
                    ],
                    type: [
                        {required: true, message: this.$t('rule.required'), trigger: 'change'}
                    ],
//                    theoryScore: [
//                        {required: true, message: this.$t('rule.required'), trigger: 'blur'}
//                    ],
//                    operationScore: [
//                        {required: true, message: this.$t('rule.required'), trigger: 'blur'}
//                    ],
                    releaseDate: [
                        {required: true, message: this.$t('rule.required'), trigger: 'change'}
                    ],
                    operateDate: [
                        {required: true, message: this.$t('rule.required'), trigger: 'change'}
                    ],
//                    grade: [
//                        {required: true, message: this.$t('rule.required'), trigger: 'change'}
//                    ],
                    place: [
                        {required: true, message: this.$t('rule.required'), trigger: 'blur'},
                        {max: 100, message: this.$t('rule.maxLength', ['100']), trigger: 'blur'}
                    ],
                    agency: [
                        {required: true, message: this.$t('rule.required'), trigger: 'blur'},
                        {max: 100, message: this.$t('rule.maxLength', ['100']), trigger: 'blur'}
                    ],
                    teachingBook: [
                        {required: true, message: this.$t('rule.required'), trigger: 'blur'},
                        {max: 100, message: this.$t('rule.maxLength', ['100']), trigger: 'blur'}
                    ],
                    trainerName: [
                        {required: true, message: this.$t('rule.required'), trigger: 'blur'},
                        {max: 50, message: this.$t('rule.maxLength', ['50']), trigger: 'blur'}
                    ],
                    category: [
                        {required: true, message: this.$t('rule.required'), trigger: 'change'},
                    ],
//                    score: [
//                        {required: true, message: this.$t('rule.required'), trigger: 'blur'}
//                    ],
                    trainDate: [
                        {required: true, message: this.$t('rule.required'), trigger: 'change'}
                    ],
                    reviewDate: [
                        {required: true, message: this.$t('rule.required'), trigger: 'change'}
                    ],
                },
                dialogFormVisible: false,//证书添加
                selectUserVisible: false,//选择用户持证人
                holderInfoShow: false,//持证人个人信息
                appendToBody: false,//对话框遮罩属性
                isCertEdit: false,//是否为编辑证书
                certDetailVisible: false,//添加记录对话框
                isEditDetail: false,//是否为编辑证书详情
                imgUploadApi:api.fileUploadURL + '/certificate',
                //从本地缓存中获得当前登录账号和等级
                //获取当前日期
                dialogVisible: false,
                pageData: null, //接收html格式代码
                htmlTitle: "危险品运输训练合格证",
                isShow: true,
                isCanvas: false,
                downType: true, // false为 pdf , true为图片,
                dangerCertID: undefined,
                dangerTableTitles: [
                    {
                        prop: 'forLevelName',
                        label: this.$t('c.operatorLevel')
                    }, {
                        prop: 'knowledgeName',
                        label: this.$t('c.knowledgePoint')
                    }, {
                        prop: 'hours',
                        label: this.$t('train.hour'),
                        sortable: 'custom'
                    }, {
                        prop: 'score',
                        label: this.$t('train.credit'),
                        sortable: 'custom'
                    },
                    {
                        prop: 'createTime',
                        label: this.$t('c.makingTime'),
                        sortable: 'custom'
                    },
                    {
                        prop: 'creatorName',
                        label: this.$t('c.producer'),
                        sortable: 'custom'
                    },
                ],
                //isHaveDangerCert: false,
                dangerTabNum: 0,
                certTableData: [],
                isDangerOverdue: false,
                dangerType:undefined,
                dangerReleaseDate:undefined,
                dangerNumber:undefined,
                dangerLoading: false
            }
        },
        mounted() {
            let userID = this.userID;
            if (userID) {
                this.initData()
                // this.queryAccount();
                // this.queryUserCert();
                // setTimeout(()=>{
                //     if(this.enterpriseCode==12 && this.isHaveDangerCert){
                //         this.getChapter()
                //         this.getElecDangerImage()
                //     }
                // },500)
            } else {
                this.queryUser();
            }
        },
        computed: {
            ...mapGetters([
                'orgTree',
            ]),
            enterpriseCode() {
                return Ticket.get().enterpriseCode
            },
            isHaveDangerCert() {
                return this.userCertList.some(v=>v.type==2)
            }
        },
        methods: {
            initData(){
                let q1 = this.queryAccount()
                let q2 = api.getCertificateQueryByUser({userID: this.userID}).then(res => {
                    if (res.package) {
                        let list = res.package;
                        if (list.length > 0) {
                            list.forEach(ele => {
                                if (ele.details.length > 0) {
                                    ele.details.reverse()
                                }
                            })
                        }
                        this.userCertList = list;
                    }
                })
                Promise.all([q1, q2]).then(()=>{
                    if(this.dangerEnterprise.includes(this.enterpriseCode) && this.isHaveDangerCert){
                        this.certTableData = this.getCertTableData()
                        this.$nextTick(() => {
                            this.dangerLoading = true
                            this.getChapter()
                            this.getElecDangerImage()
                        })
                    }
                })

            },
            makeElecImage(){
                this.getChapter();
                this.getElecDangerImage()
            },
            getCertTableData(){
                let data = []

                for(let i=0;i<9;i++){
                    data.push({'approvalNo':' ','trainDate':' ','teachingBook':' ','category':' ','gradeName':' ','trainerName':' '})
                }
                let index = this.userCertList.findIndex(v=>v.type==2)

                if(index>-1){
                    // this.isHaveDangerCert = true
                    this.dangerCertID = this.userCertList[index].id
                    this.dangerTabNum = index
                    this.dangerReleaseDate =this.userCertList[index].releaseDate.substring(0,10)
                    this.dangerNumber =this.userCertList[index].number
                    this.userCertList[index].details.forEach((item,idx)=>{
                        if(idx<9){
                            data[idx].approvalNo = 'ZN-SZ-TP-0450'
                            data[idx].trainDate = item.trainDate
                            data[idx].teachingBook = item.teachingBook
                            data[idx].category = item.category?(item.category+'类'):item.category
                            data[idx].gradeName = item.gradeName
                            data[idx].trainerName = item.trainerName
                        }
                        if(idx == (this.userCertList[index].details.length-1)){
                            this.dangerCategory = item.category
                            this.isDangerOverdue = this.compareReleaseTime(item.trainDate.substring(0,10))
                        }
                    })
                }
                return data
            },
            handleClose() {
                this.dialogVisible = false;
            },
            getElecDangerImage(){
                var title = this.htmlTitle // 导出名称
                var htmlID = document.getElementById('imageDom')

                let that = this

                html2Canvas(htmlID, {
                    allowTaint: true,
                    // scrollY: 50, // 偏移量吧，如果有滚动条影响，但是不想设置滚动条置顶， 可以设置这个，但是要计算滚动了多少
                    // scrollX:0,
                    // x:0, // 距离左边距离
                    // y:10,
                    // 下面两个用来提高清晰度
                    // dpi: window.devicePixelRatio*4, //将分辨率提高到特定的DPI 提高四倍
                    scale:2, //按比例增加分辨率
                    useCORS: true // 【重要】开启跨域配置
                }).then(function (canvas) {
                    let contentWidth = canvas.width
                    let contentHeight = canvas.height
                    console.log(contentWidth, contentHeight)

                    if (contentWidth < 1040) {
                        console.log('×重新渲染...')
                        that.getElecDangerImage()
                        return
                    }

                    console.log('√渲染完成')
                    that.dangerLoading = false

                    // 1.0 清晰度0-1
                    let file = canvas.toDataURL('image/jpeg', 1.0)
                    that.canvasUrl = file
                    var formData = new FormData();
                    let blob= that.dataURLtoFile(file, 'image/jpeg')
                    let fileOfBlob = new File([blob], new Date()+'.jpg')
                    formData.append('upfile', fileOfBlob);
                    formData.append('id', that.dangerCertID);  //通过append向form对象添加数据
                    formData.append('access_token', Ticket.get().access_token);  //通过append向form对象添加数据

                    api.uploadCertificateImage(formData).then(res => {
                        that.$set(that.userCertList[that.dangerTabNum],'photo',res.url)
                    })
                })
            },
            dataURLtoFile(dataURI, type) {
                let binary = atob(dataURI.split(',')[1]);
                let array = [];
                for(let i = 0; i < binary.length; i++) {
                        array.push(binary.charCodeAt(i));
                }
                return new Blob([new Uint8Array(array)], {type:type });
            },
            // 生成印章
            getChapter() {
                if(!this.isCanvas) {
                    // 只绘画一次
                    this.isCanvas = true
                    var canvas = document.getElementById("chapterCanvas");
                    var context = canvas.getContext("2d");

                    var text = "xxx专用章";
                    var companyName = "深圳航空有限公司"
                    //  context.translate(0, 0);
                    // context.clearRect(0, 0, 200, 200);//清除整个画布
                    // 绘制印章边框
                    var width = canvas.width / 2;
                    var height = canvas.height / 2;
                    context.lineWidth = 3;
                    context.strokeStyle = "#cf0c0c";
                    context.beginPath();
                    context.arc(width, height, 80, 0, Math.PI * 2); //宽、高、半径
                    context.stroke();

                    //画五角星
                    create5star(context, width, height, 15, "#cf0c0c", 0);

                    // 绘制印章名称
                    context.font = "20px 宋体";
                    context.textBaseline = "middle"; //设置文本的垂直对齐方式
                    context.textAlign = "center"; //设置文本的水平对对齐方式
                    context.lineWidth = 1;
                    context.strokeStyle = "#cf0c0c";
                    // context.strokeText(text, width, height + 30); // 名称 xx专用章

                    // 绘制印章单位
                    context.translate(width, height); // 平移到此位置,
                    context.font = "20px 宋体";
                    var count = companyName.length; // 字数
                    var angle = (2.8 * Math.PI) / (3 * (count - 1)); // 字间角度
                    var chars = companyName.split("");
                    var c;
                    for (var i = 0; i < count; i++) {
                        c = chars[i]; // 需要绘制的字符
                        if (i == 0) {
                        context.rotate((6.2 * Math.PI) / 6);// 文字起始位置
                        } else {
                        context.rotate(angle);
                        }

                        context.save();
                        context.translate(62, 0); // 平移到此位置,此时字和x轴垂直，公司名称和最外圈的距离
                        context.rotate(Math.PI / 2); // 旋转90度,让字平行于x轴
                        context.strokeText(c, 0, 0); // 此点为字的中心点
                        context.restore();
                    }

                    //绘制五角星
                    function create5star(context, sx, sy, radius, color, rotato) {
                        context.save();
                        context.fillStyle = color;
                        context.translate(sx, sy); //移动坐标原点
                        context.rotate(Math.PI + rotato); //旋转
                        context.beginPath(); //创建路径
                        var x = Math.sin(0);
                        var y = Math.cos(0);
                        var dig = (Math.PI / 5) * 4;
                        for (var i = 0; i < 5; i++) {
                        //画五角星的五条边
                        var x = Math.sin(i * dig);
                        var y = Math.cos(i * dig);
                        context.lineTo(x * radius, y * radius);
                        }
                        context.closePath();
                        context.stroke();
                        context.fill();
                        context.restore();
                    }
                }
            },
            closeFn() {
                this.$router.replace({name: 'certificate'});
                this.$emit('onClose');
            },
            // 查询持证人信息
            queryAccount() {
                let userID = this.userID;
                return api.getUserDetail(userID).then(res => {
                    if (res.package) {
                        this.currentUser = res.package
                    }
                })
            },
            // 查询持证人证书
            queryUserCert() {
                let userID = this.userID;
                api.getCertificateQueryByUser({userID: userID}).then(res => {
                    if (res.package) {
                        let list = res.package;
                        if (list.length > 0) {
                            list.forEach(ele => {
                                if (ele.details.length > 0) {
                                    ele.details.reverse()
                                }
                            })
                        }
                        this.userCertList = list;
                    }
                })
            },

            // 查询用户列表
            queryUser() {
                this.currentPage = 1;
                let queryData = this.userSearch;
                api.queryUsers(queryData).then(res => {
                    if (res.package) {
                        this.tableData = res.package
                        this.tableData.forEach(item=>{
                            item.employmentDate = item.employmentDate && item.employmentDate.split(' ')[0];
                        })
                    } else {
                        this.tableData = []
                    }
                })
            },
            selectUser() {
                this.selectUserVisible = true;
            },
            orgsChange(data) {
                this.userSearch.orgIds = data;
            },
            // 赋值给radio
            handleCurrentChange(row) {
                if (row&&row.id) {
                    this.radio = row.id
                }
            },
            // 当表格的当前行发生变化的时候触发
            showRow(val, index) {
                this.currentUser = val;
            },
            getCurrentRow(val) {
            },
            // 确定持证人
            submitUser() {
                let user = this.currentUser;
                let formData = this.formData;
                if (user) {
                    this.selectUserVisible = false;
                    this.holderInfoShow = true;
                    formData['userID'] = user.id;
                    this.userID = user.id;
                    this.queryUserCert();
                } else {
                    this.$message.error(this.$t('cert.selectHolderTip'));
                }
            },
            // 为持证人添加、编辑证书
            addCertificates(certID) {
                // 添加
                this.$refs['addCerts'] && this.$refs['addCerts'].resetFields();
                this.$refs['certsDetail'] && this.$refs['certsDetail'].resetFields();
                this.dialogFormVisible = true;
                this.isCertEdit = false;

                // 编辑
                if (certID) {
                    this.isCertEdit = true;
                    api.getCertificateById(certID).then(res => {
                        if (res.package) {
                            this.certID = certID
                            for (let item in this.formData) {
                                this.formData[item] = res.package[item]
                            }
                        }
                        this.dialogFormVisible = true
                    })
                }
            },
            // 添加、编辑证书->提交
            addCertSubmit(addCerts) {
                let _this = this;
                let data = {...this.formData};
                this.$refs[addCerts].validate((valid) => {
                    if (!valid) return;

                    let date1 = data.releaseDate.replace(/-/g, "/");
                    let date2 = data.operateDate.replace(/-/g, "/");
                    if (!this.isCertEdit) {
                        // 判断取证日期是否大于发证日期
                        if (date2 < date1) {
                            this.$message.error(this.$t('m.endingTime'));
                        } else {
                            // 判断是否是危险品证书
                            if (data.type == '2') {
                                data.details = [{
                                    agency: data.agency,
                                    place: data.place,
                                    trainerName: data.trainerName,
                                    teachingBook: data.teachingBook,
                                    category: data.category,
                                }];
                                data.agency = undefined;
                                data.place = undefined;
                                data.trainerName = undefined;
                                data.teachingBook = undefined;
                                data.category = undefined;
                            }

                            api.addCert(data).then(res => {
                                this.$message.success(this.$t('m.addSuccess'));
                                _this.queryUserCert();
                                this.dialogFormVisible = false;
                                this.$parent.query()
                            })
                        }
                    } else {
                        // 编辑证书
                        let id = this.certID;
                        if (date2 < date1) {
                            this.$message.error(this.$t('m.endingTime'));
                        } else {
                            api.editCertificate(id, data).then(res => {
                                this.$message.success(this.$t('m.editSuccess'));
                                _this.queryUserCert();
                                this.dialogFormVisible = false
                                this.$parent.query()
                            })
                        }
                    }
                });
            },
            // 删除证书
            deleteCert(deleteID) {
                let id = deleteID;
                let _this = this;
                this.$confirm(this.$t('m.delCert'), this.$t('m.tip'), {
                    type: 'warning'
                }).then(() => {
                    api.deleteCertificate(id).then(res => {
                        this.activeTab = '0';
                        _this.queryUserCert();
                        this.$message.success(this.$t('m.delSuccess'));
                        this.$parent.query()
                    })
                }).catch(() => {
                })
            },
            addDetail(item) {
                this.isEditDetail = false;
                this.certDetailVisible = true;
                this.$refs['addCertsRecord'] && this.$refs['addCertsRecord'].resetFields();
                this.detailType = item.type;
                this.detailData.id = item.id;
                this.detailData.certID = item.id;
            },
            editDetail(item, msg) {
                this.isEditDetail = true;
                if (msg == 'danger') {
                    this.detailType = 2;
                } else {
                    this.detailType = ''
                }
                this.certDetailVisible = true;
                api.getCertificateDetail(item.id).then(res => {
                    this.detailData = res.package;
                })
            },
            addDetailSubmit(formName) {
                let data = this.detailData;
                let _this = this;
                this.$refs[formName].validate((valid) => {
                    if (!valid) return;

                    if (!this.isEditDetail) {
                        api.addCertificateDetail(data).then(res => {
                            this.$message.success(this.$t('m.addSuccess'));
                            this.certDetailVisible = false;
                            _this.queryUserCert();
                            this.$parent.query();
                        })
                    } else {
                        let id = this.detailData.id;
                        api.editCertificateDetail(id, data).then(res => {
                            this.$message.success(this.$t('m.editSuccess'));
                            this.certDetailVisible = false;
                            _this.queryUserCert();
                            this.$parent.query();
                        })
                    }
                });
            },
            deleteDetail(item) {
                let id = item.id;
                let _this = this;
                this.$confirm(this.$t('m.delete'), this.$t('m.tip'), {
                    type: 'warning'
                }).then(() => {
                    api.deleteCertificateDetail(id).then(res => {
                        if (res.message == 'Success') {
                            this.$message.success(this.$t('m.delSuccess'));
                        }
                    })
                        .then(() => {
                            _this.queryUserCert();
                            _this.$parent.query()
                        })
                }).catch(() => {
                })
            },
            //证书图片
            showImage(url){
                let imageUrl = url + '?access_token='+Ticket.get().access_token
                console.log(imageUrl)
                return imageUrl
            },
            handleAvatarSuccess(res, file) {
                if (res.result) {
                    this.$set(this.userCertList[this.activeTab],'photo',res.url)
                } else {
                    this.$message.error(res.message);
                }
            },
            deleteImage(id){
                this.$confirm(this.$t('m.delete'), this.$t('m.tip'), {
                    type: 'warning'
                }).then(() => {
                    api.deleteCertPhoto(id).then(res=>{
                       this.$message.success(this.$t('m.delSuccess'));
                        this.$set(this.userCertList[this.activeTab],'photo','')
                    })
                }).catch(() => {
                });
            },
            uploadParams(id){
                let params={
                    'id':id,
                    'access_token': Ticket.get().access_token
                }
                return params
            },
            rowStyle({row, column, rowIndex, columnIndex}){
                if(columnIndex==0){
                    return 'border-bottom:1px dotted #76889c;border-right:1px dotted #76889c;text-decoration:underline';
                }
                else{
                    return 'border-bottom:1px dotted #76889c;border-right:1px dotted #76889c;';
                }

            },
            compareReleaseTime(date1){
                const myDate = new Date()
                myDate.setFullYear(myDate.getFullYear()-2)
                let nowY = myDate.getFullYear();
                let nowM = myDate.getMonth()+1;
                let nowD = myDate.getDate();
                let twoAgo = nowY+"-"+(nowM<10 ? "0" + nowM : nowM)+"-"+(nowD<10 ? "0"+ nowD : nowD);
                return twoAgo>date1
            },
            // 时间戳的作用是在页面刷新智慧使浏览器不使用缓存图片
            avatarLazy:function(g){
                console.log(11111111, g);
                return g + '?t=' + new Date().getTime()
            }
        },
        components: {
            SubPage,
            SelectMultiOrgs,
        }
    }
</script>

<style scoped lang="scss">
    @import '../../style/const.scss';
    .certificate {
        width: 100%;
        display: flex;
        height: 100%;
        .certificate-holder,
        .certificate-info {
            border: 1px solid #ccc;
            flex: 1;
            overflow: auto;
        }
        .certificate-info {
            height: 100%;
            .notice-tag {
                background: #188ae2;
                color: #fff;
                border: none;
                position: relative;
                left: 50%;
                top: 30%;
                transform: translateX(-50%);
            }
        }
        .certificate-holder {
            padding: 20px 0 0 0;
            margin: 0 0 0 30px;
            border-right: none;
            .holder-select {
                height: 60px;
                .holder-head {
                    width: 70%;
                    margin: auto;
                }
            }
            .holder-info {
                font-size: 14px;
                .holder-head {
                    width: 60%;
                    margin: auto;
                    margin-bottom: 15px;
                    text-align: center;
                    img {
                        padding: 4px;
                        border-radius: 4px;
                        background: #dbdbdb;
                        width: 80px;
                        height: 80px;
                        margin-bottom: 8px;
                    }
                }
                .holder-body {
                    width: 100%;
                    margin: auto;
                    padding: 10px 0 0;
                    border-top: 1px solid #ccc;
                    li {
                        padding: 0 30px;
                        height: 32px;
                        line-height: 32px;
                        border-bottom: 1px dashed #e6e6e6;
                        h5 {
                            display: inline-block;
                        }
                        span {
                            color: #999999;
                        }
                    }
                    .holder-btn {
                        background: #188ae2;
                        color: #fff;
                        position: relative;
                        left: 50%;
                        margin: 20px 0 0;
                        transform: translateX(-50%)
                    }
                }
            }
        }
        .box-card {
            border: none;
            width: 96%;
            margin: 15px 20px 0;
            .cert-info {
                li {
                    padding: 6px 10px;
                    color: #6c6c6c;
                    border-bottom: 1px solid #e8e8e8;
                }
            }
            .cert-detail {
                height: auto;
                border-left: 3px solid #f5f7fa;
                padding-left: 40px;
                margin: 0 0 0 24px;
                .cert-detail-title {
                    border: 1px solid #e7e7e7;
                    position: relative;
                    background: #f5f7fa;
                    padding: 10px 15px;
                    .icon-style {
                        position: absolute;
                        left: -68px;
                        top: -3px;
                        width: 50px;
                        height: 50px;
                        line-height: 45px;
                        border-radius: 50%;
                        background-color: #408db6;
                        text-align: center;
                        border: 3px solid #e0f4ff;
                        color: #fff;
                        .inuc-zhengshu,
                        .inuc-fuxun {
                            margin: auto;
                            font-size: 18px;
                        }
                    }
                    .icon-style-1 {
                        background-color: #f8ad58;
                        border: 3px solid #fff3e6;
                    }
                    .detail-tag {
                        margin-bottom: 6px;
                        border: 1px dashed #e5e5e8;
                    }
                    .danger-detail-list {
                        width: 100%;
                        display: flex;
                        flex-wrap: wrap;
                        justify-content: space-between;
                        li {
                            min-width: 33%;
                            margin-top: 6px;
                        }
                    }
                }
                .cert-detail-title:after {
                    content: '';
                    position: absolute;
                    top: 8px;
                    right: 100%;
                    height: 0;
                    width: 0;
                    border: 8px solid transparent;
                    border-right: 11px solid #f5f8f9;
                }
                .cert-detail-title:nth-child(odd) {
                    background: #fff;
                }
                .cert-detail-title:nth-child(even) {
                    border-top: none;
                    border-bottom: none;
                }
                .cert-detail-title:nth-child(even):after {
                    border-right: 11px solid #f5f7fa;
                }
            }
            .inuc-zhengshuxiangqing,
            .inuc-fuxunjilu {
                margin-right: 5px;
                color: #1c84c6;
            }
        }
        .box-card.cert-box-card,
        .box-card.detail-box-card {
            height: auto;
        }
        .cert-container {
            height: 100%;
            font-size: 14px;
        }
        .cert-container /deep/ .el-card__header {
            padding: 0 10px;
            background: #f4f3f8;
            border: 1px solid #ebebec;
        }
        .cert-container /deep/ .el-card__body {
            padding: 10px 15px 0;
        }
        .cert-container /deep/ .el-tabs__content {
            height: 95%;
        }
        .inuc-edit,
        .inuc-delete,
        .inuc-add-circle{
            font-size: 14px;
            color: #a3a4a9;
        }
    }
    /*修改element-ui tabs的样式*/
    .certificate /deep/ .el-tabs--border-card {
        box-shadow: none;
        padding-bottom: 10px;
    }

    .certificate /deep/ .el-tabs__item {
        padding: 0 15px !important;
        text-align: center;
    }
    .certificate /deep/ .el-tabs--border-card > .el-tabs__header .el-tabs__item:not(.is-disabled):hover,
    .certificate /deep/ .el-tabs__item.is-active {
        background: #2e7faa;
        color: #fff;
    }


    /*选择用户弹框*/
    .el-style {
        width: 250px;
    }
    .el-radio__label {
        display: none;
    }
    .dialog-footer {
        text-align: center;
        margin-top: 20px;
        button {
            width: 100px;
        }
    }
    #imageDom{
        position: absolute;
        width: 1220px;
        height: 655px;
        clip: rect(0,0,0,0);
    }
    .elec-danger-image{
        border: 1px dashed #d9d9d9;
        width: 220px;
        height: 178px;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        /* overflow: hidden; */
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        outline: none;
        margin-left: 74px;
    }

    .proBox {
    /* 奖状的模板 */
        position: relative;
        // background: url("../../assets/images/common/cert_bg.png") no-repeat;
        // background-size: cover;
        width: 100%;
        height: 100%;
        // border: 6px solid #9e1b51;
        padding: 15px 30px;
        box-sizing: border-box;
        margin: 0 auto;
        color: #000;
        font-family: SimSun;
    }
    .shenzhen-logo{
        position: absolute;
        top: 56px;
        right: 90px;
        width: 40px;
        height: 40px;
        >img{
            width: 100%;
            height: 100%;
        }
    }
    .tit {
        font-size: 32px;
        font-weight: 600;
        letter-spacing: 3px;
        font-family: "微软雅黑";
        margin-bottom: 10px;

    }
    .sub-title{
        font-size: 18px;
        letter-spacing: 1px;
        margin-bottom: 25px;
        font-family: "微软雅黑";
    }
    .s-cert-info{
        position: relative;
        display: flex;
        justify-content: space-between;
        .s-person-info{
            // width: 30%;
            // padding-top: 30px;
            font-weight: 600;
            font-size: 18px;
            font-family: "微软雅黑";
            letter-spacing: 1px;

            .s-user-photo{
                // display: flex;
                // justify-content: center;
                // align-content: center;
                width: 130px;
                height: 130px;
                border: 1px solid #9e1b51;
                margin-left: 20px;
                margin-bottom: 10px;
                >img{
                    max-width: 100%;
                    max-height: 100%;
                }
            }

        }
        .s-cert-list{
            border: 2px solid #76889c;
            border-radius: 2px;
            // width: 70%;
        }
        .s-cert-overdue{
            position: absolute;
            width: 80px;
            height: 80px;
            left: 220px;
            >img{
                width: 100%;
                height: 100%;
            }
        }
    }
    .proid {
        text-align: right;
        margin: 0;
        font-weight: 500;
    }
    .elec-cert-title{
        padding: 6px 10px;
        color: #6c6c6c;
    }
    .elec-cert-area{
        width:300px;
        height:240px;
        margin-left:80px;
        border:1px solid #ddd;
        overflow:scroll
    }
    .shuaxin-image{
        cursor: pointer;
        .nucfont{
            font-size: 22px;
        }
        &:hover{
            color: #00bcd4;
            .nucfont{
                font-size: 26px;
            }
        }
    }



    .con-footer {
        font-size: 18px;
        font-weight: 700;
        position: absolute;
        bottom: 45px;
        left: 0;
        right: 0;
        text-align: center;
    }
    .chapter {
        border-radius: 50%;
        position: absolute;
        bottom: 50px;
        left: 130px;
        // right: 134px;
    }
    .button{
        margin: 50px 50px;
        position: absolute;
        font-family: '华文行楷, STXingkai';
        font-weight: 700;
        font-size: 2em
    }
</style>
<style lang="scss">
    #cert-box {
        > .el-main,
        .el-card__body {
            overflow: hidden;
        }
    }
    .certificate{
        .avatar-uploader{
            margin-left: 74px;
            /*margin-top: 5px;*/
            .el-upload {
                border: 1px dashed #d9d9d9;
                width: 220px;
                height: 178px;
                border-radius: 6px;
                cursor: pointer;
                position: relative;
                /*overflow: hidden;*/
                display: flex;
                justify-content: center;
                align-items: center;
                &:hover{
                    border-color: #409EFF;
                    .mask{
                        display: block;
                    }
                }
            }
            .avatar-uploader-icon {
                font-size: 28px;
                color: #8c939d;
                width: 220px;
                height: 178px;
                line-height: 178px;
                text-align: center;
            }
            .mask {
                position: absolute;
                display: none;
                left: 0;
                bottom: 0;
                right: 0;
                /*background-color: #000;*/
                /*opacity: 0.6;*/
                /*transition: all .3s ease-in-out;*/
                text-align: right;
                padding-right: 20px;

                height: 40px;
                background-color: rgba(0, 0, 0, 0.5);
                -webkit-transition: opacity .3s;
                transition: opacity .3s;
                line-height: 40px;
                >i{
                    font-size: 18px;
                    color: #fff;
                }
            }
            .avatar {
                max-height:100%;
                display: block;
            }
        }



    }
    .s-cert-info{

        .el-table{
            border-left: #f2f2f2;
            border-right: #f2f2f2;
        }
        .el-table th {
            color: #fff;
            font-size: 16px;
            background-color: #9e1b51;
            border-right: 1px dotted #76889c;
            > .cell{
                font-family: STHeiti;
                // letter-spacing: 2px;
            }
        }
        .el-table td {
            font-family: STHeiti;
            border-bottom: none;
            height: 47px;
            .cell{
                padding: 0;
            }
        }
        .el-table--striped .el-table__body tr.el-table__row--striped td{
            background-color: #f2f2f2;
        }

    }
</style>
